<!-- <p>mobile-table-card works!</p> -->
<div
  [ngClass]="{
    'mobile-table-card-wrapper': !isAssetWall,
    'mobile-table-card-wrapper-asset-wall': isAssetWall,
    'mobile-table-card-wrapper-asset': isAssets,
    'mobile-table-card-wrapper-asset-timeslot': isTimeSlots
  }"
>
  <section *ngIf="isVisitor">
    <div
      *ngFor="let visitor of visitorList"
      class="mobile-table-card-container"
    >
      <div class="card-content">
        <div>
          Name : <b>{{ visitor.firstName + " " + visitor.lastName }}</b>
        </div>
        <div>
          Date :
          <b>{{
            getFormatedDate(visitor.visitDateTime) | date : "dd/MM/yy"
          }}</b>
        </div>
        <div>
          Host :
          <b
            [ngStyle]="
              visitor.securityStatus == 4
                ? { color: 'green', 'font-size': '16px' }
                : visitor.securityStatus == 5
                ? { color: 'red', 'font-size': '16px' }
                : {}
            "
            >{{ visitor.hostName }}
          </b>
        </div>
        <div>
          Purpose :
          <b>{{ visitor.purpose ? visitor.purpose : "Not Mentioned" }}</b>
        </div>
        <div *ngIf="visitor.isPreApproved && isSecurityLog">
          Status :
          <button
            class="security-button"
            [ngStyle]="
              visitor.checkIn == null
                ? { 'background-color': 'lightskyblue', color: 'black' }
                : visitor.checkIn &&
                  visitor.checkOut == null &&
                  (getExpectedCheckoutTimeNumber(visitor) | async) > 15
                ? { 'background-color': 'green', color: 'white' }
                : visitor.checkIn &&
                  visitor.checkOut == null &&
                  (getExpectedCheckoutTimeNumber(visitor) | async) <= 15 &&
                  (getExpectedCheckoutTimeNumber(visitor) | async) >= 2
                ? { 'background-color': 'orange', color: 'white' }
                : visitor.checkIn &&
                  visitor.checkOut == null &&
                  (getExpectedCheckoutTimeNumber(visitor) | async) < 2
                ? { 'background-color': 'red', color: 'white' }
                : { 'background-color': 'darkgray' }
            "
            mat-raised-button
          >
            {{
              visitor.checkIn == null
                ? "Not yet arrived"
                : visitor.checkIn &&
                  visitor.checkOut == null &&
                  (getExpectedCheckoutTimeNumber(visitor) | async) > 0
                ? (getExpectedCheckoutTime(visitor) | async)
                : visitor.checkIn &&
                  visitor.checkOut == null &&
                  (getExpectedCheckoutTimeNumber(visitor) | async) == 0
                ? "Time Expired"
                : visitor.checkOut != null
                ? "Visited"
                : ""
            }}
          </button>
        </div>
      </div>
      <div class="card-action">
        <button
          *ngIf="isSecurityLog && visitor.isPreApproved == null"
          [ngStyle]="
            visitor.securityStatus == 1 ||
            visitor.securityStatus == 4 ||
            visitor.securityStatus == 5
              ? { 'background-color': 'green' }
              : visitor.securityStatus == -1 || visitor.securityStatus == 3
              ? { 'background-color': '#FFBF00' }
              : { 'background-color': 'red' }
          "
          mat-raised-button
        >
          {{
            visitor.securityStatus == 0
              ? "Unverified"
              : visitor.securityStatus == 1
              ? "Verified"
              : visitor.securityStatus == -1
              ? "Rejected"
              : visitor.securityStatus == 3
              ? "Auto Rejected"
              : visitor.securityStatus == 4
              ? "In Progress"
              : visitor.securityStatus == 5
              ? "Completed"
              : "Pending"
          }}
        </button>
        <button
          *ngIf="
            visitor.isPreApproved == 'true' &&
            visitor.securityStatus == 0 &&
            isShowAction
          "
          (click)="onAction(visitor)"
          mat-raised-button
        >
          Action
        </button>
        <button (click)="onShowDetails(visitor)" mat-raised-button>
          {{ "Details" }}
        </button>
      </div>
    </div>
  </section>
  <section *ngIf="isPendingVisitor">
    <div
      *ngFor="let visitor of visitorList"
      class="mobile-table-card-container"
    >
      <div class="card-content">
        <div>
          Name : <b>{{ visitor.firstName + " " + visitor.lastName }}</b>
        </div>
        <div>
          Date :
          <b>{{
            getFormatedDate(visitor.visitDateTime) | date : "dd/MM/yy, h:mm a'"
          }}</b>
        </div>
        <div>
          Host :
          <b>{{ visitor.hostName }} </b>
        </div>
        <div>
          Purpose :
          <b>{{ visitor.purpose ? visitor.purpose : "Not Mentioned" }}</b>
        </div>
      </div>
      <div class="card-action">
        <button
          [ngStyle]="
            visitor.securityStatus == 1
              ? { 'background-color': 'green' }
              : visitor.securityStatus == -1 || visitor.securityStatus == 3
              ? { 'background-color': '#FFBF00' }
              : { 'background-color': 'red' }
          "
          mat-raised-button
        >
          {{
            visitor.securityStatus == 1 && visitor.isPreApproved != "true"
              ? "Approved"
              : visitor.securityStatus == 1 && visitor.isPreApproved == "true"
              ? "Pre-Approved"
              : visitor.securityStatus == 0 &&
                visitor.isPreApproved != "true" &&
                visitor.isGateEntry == "1"
              ? "Pending"
              : visitor.securityStatus == -1
              ? "Rejected"
              : visitor.securityStatus == 3
              ? "Auto Rejected"
              : visitor.securityStatus == 0 && visitor.isPreApproved == "true"
              ? "Pre-Approved"
              : "Unverified"
          }}
        </button>
        <button
          *ngIf="
            isOpenApprovalSection(visitor) &&
            (visitor.securityStatus == 3 || visitor.securityStatus == 0) &&
            visitor.isPreApproved != 'true' &&
            visitor.isGateEntry == '1'
          "
          (click)="onShowDetails(visitor)"
          mat-raised-button
        >
          {{ "Action" }}
        </button>
      </div>
    </div>
  </section>
  <section *ngIf="isGateVisitor">
    <div
      *ngFor="let visitor of visitorList"
      class="mobile-table-card-container"
    >
      <div class="card-content">
        <div>
          Name : <b>{{ visitor.firstName + " " + visitor.lastName }}</b>
        </div>
        <div>
          Date :
          <b>{{
            getFormatedDate(visitor.visitDateTime) | date : "dd/MM/yy, h:mm a'"
          }}</b>
        </div>
        <div>
          Host :
          <b
            [ngStyle]="
              visitor.securityStatus == 4
                ? { color: 'green', 'font-size': '16px' }
                : visitor.securityStatus == 5
                ? { color: 'red', 'font-size': '16px' }
                : {}
            "
            >{{ visitor.hostName }}
          </b>
        </div>
        <div *ngIf="visitor.isPreApproved != 'true'">
          Purpose :
          <b>{{ visitor.purpose ? visitor.purpose : "Not Mentioned" }}</b>
        </div>
        <div *ngIf="visitor.isPreApproved == 'true'">
          Status :
          <button
            *ngIf="visitor.isPreApproved == 'true'"
            class="security-button"
            [ngStyle]="
              visitor.checkIn == null
                ? { 'background-color': 'lightskyblue', color: 'black' }
                : visitor.checkIn &&
                  visitor.checkOut == null &&
                  (getExpectedCheckoutTimeNumber(visitor) | async) > 15
                ? { 'background-color': 'green', color: 'white' }
                : visitor.checkIn &&
                  visitor.checkOut == null &&
                  (getExpectedCheckoutTimeNumber(visitor) | async) <= 15 &&
                  (getExpectedCheckoutTimeNumber(visitor) | async) >= 2
                ? { 'background-color': 'orange', color: 'white' }
                : visitor.checkIn &&
                  visitor.checkOut == null &&
                  (getExpectedCheckoutTimeNumber(visitor) | async) < 2
                ? { 'background-color': 'red', color: 'white' }
                : { 'background-color': 'darkgray' }
            "
            mat-raised-button
          >
            {{
              visitor.checkIn == null
                ? "Not yet arrived"
                : visitor.checkIn &&
                  visitor.checkOut == null &&
                  (getExpectedCheckoutTimeNumber(visitor) | async) > 0
                ? (getExpectedCheckoutTime(visitor) | async)
                : visitor.checkIn &&
                  visitor.checkOut == null &&
                  (getExpectedCheckoutTimeNumber(visitor) | async) == 0
                ? "Time Expired"
                : visitor.checkOut != null
                ? "Visited"
                : ""
            }}
          </button>
        </div>
      </div>
      <div class="card-action">
        <button
          [ngStyle]="
            visitor.securityStatus == 1 ||
            visitor.securityStatus == 4 ||
            visitor.securityStatus == 5
              ? { 'background-color': 'green' }
              : visitor.securityStatus == -1 || visitor.securityStatus == 3
              ? { 'background-color': '#FFBF00' }
              : { 'background-color': 'red' }
          "
          mat-raised-button
        >
          {{
            visitor.securityStatus == -1
              ? "Rejected"
              : visitor.securityStatus == 1
              ? "Approved"
              : visitor.securityStatus == 3
              ? "Auto Rejected"
              : visitor.securityStatus == 0 && visitor.isPreApproved == "true"
              ? "Pre-Approved"
              : visitor.securityStatus == 4
              ? "In Progress"
              : visitor.securityStatus == 5
              ? "Completed"
              : "Pending"
          }}
        </button>

        <button
          *ngIf="
            isOpenApprovalSection(visitor) &&
            visitor.isPreApproved != 'true' &&
            visitor.securityStatus == 0
          "
          (click)="onShowDetails(visitor)"
          mat-raised-button
        >
          {{ "Refresh" }}
        </button>
        <button
          *ngIf="isOpenApprovalSection(visitor) && visitor.securityStatus == 3"
          (click)="onShowDetails(visitor)"
          mat-raised-button
        >
          {{ "Action" }}
        </button>
        <button
          *ngIf="visitor.isPreApproved == 'true' && visitor.securityStatus == 0"
          (click)="onShowDetails(visitor)"
          mat-raised-button
        >
          Action
        </button>
      </div>
    </div>
  </section>
  <section *ngIf="isIncident">
    <div
      *ngFor="let incident of incidentList"
      class="mobile-table-card-container"
    >
      <div class="card-content">
        <div>
          Incident Id :
          <b> {{ incident.incidentId.split("-")[0] }}</b>
        </div>
        <div>
          Date :
          <b>{{
            getFormatedDate(incident.eventCreateDate)
              | date : "dd/MM/yy, hh:mm:ss a'"
          }}</b>
        </div>
        <div>
          Incident Name :
          <b>{{ incident.incidentName }} </b>
        </div>
        <div>
          Description :
          <b>{{ incident.incidentDescription | truncateCase : 45 }}</b>
        </div>
      </div>
      <div class="card-action">
        <button
          [ngStyle]="
            incident.incidentStatus == 3
              ? { 'background-color': '#ffbf00' }
              : incident.incidentStatus == 0
              ? { 'background-color': 'green' }
              : incident.incidentStatus == 1
              ? { 'background-color': 'red' }
              : { 'background-color': 'gray' }
          "
          mat-raised-button
          (click)="onSnoozeIncident(incident)"
        >
          {{
            incident.incidentStatus == 1
              ? "Closed"
              : incident.incidentStatus == 0
              ? "Open"
              : incident.incidentStatus == 2
              ? "Verified"
              : incident.incidentStatus == 3
              ? "Snoozed"
              : incident.incidentStatus == 4
              ? "In-Progress"
              : incident.incidentStatus == 5
              ? "On-Hold"
              : incident.incidentStatus == 6
              ? "Approved"
              : incident.incidentStatus == 7
              ? "Rejected"
              : incident.incidentStatus == 8
              ? "Completed"
              : ("Not Specified" | titlecase)
          }}
          <!-- {{ incident.incidentStatus == 3 ? "Snoozed" : "Snooze" }} -->
        </button>
        <button (click)="onShowDetails(incident)" mat-raised-button>
          Details
        </button>
      </div>
    </div>
  </section>
  <section *ngIf="isAssetWall">
    <div *ngFor="let asset of assetList" class="mobile-table-card-container">
      <div style="width: 100%" class="card-content">
        <div>
          Asset Name : <b>{{ asset.assetName | titlecase }}</b>
        </div>
        <div>
          Asset Type : <b>{{ asset.assetType }}</b>
        </div>
        <div>
          Asset Location : <b> {{ getAssetlocation(asset.assetLocation) }}</b>
        </div>
        <div>
          Date :
          <b>{{ getFormatedDate(asset.assetCreateDate) | date : "short" }}</b>
        </div>
      </div>
    </div>
  </section>
  <section *ngIf="isProperty">
    <div
      *ngFor="let property of propertyList"
      class="mobile-table-card-container"
    >
      <div class="card-content">
        <div>
          Property Name : <b>{{ property.propName }}</b>
        </div>

        <div>
          Property Type : <b>{{ property.propType }}</b>
        </div>
        <div>
          Date : <b>{{ property.propCreateDate | date : "short" }}</b>
        </div>
        <div>
          Total Assets :
          <b>
            {{
              property.assetDetails?.length
                ? property.assetDetails?.length
                : "0"
            }}</b
          >
        </div>
      </div>
      <div class="card-action">
        <button (click)="onShowDetails(property)" mat-raised-button>
          Details
        </button>
      </div>
    </div>
  </section>
  <section *ngIf="isAssets || isAssetsDetails">
    <div *ngFor="let asset of assetList" class="mobile-table-card-container">
      <div class="card-content">
        <div>
          Asset Name : <b>{{ asset.assetName | titlecase }}</b>
        </div>
        <div>
          Asset Type : <b>{{ asset.assetType }}</b>
        </div>
        <div>
          Asset Location : <b>{{ asset.assetLocation | titlecase }}</b>
        </div>
        <div>
          Date :
          <b>{{ asset.assetCreateDate | date : "short" }}</b>
        </div>
      </div>
      <div class="card-action">
        <button (click)="onShowDetails(asset)" mat-raised-button>
          Details
        </button>
      </div>
    </div>
  </section>
  <section *ngIf="isTimeSlots">
    <div *ngFor="let slot of timeSlotsList" class="mobile-table-card-container">
      <div class="card-content">
        <div class="card-content-timeslots">
          Time-Slot : <b>{{ slot.time | date : "hh:mm a" }}</b>
          <mat-radio-button
            (change)="onShowDetails(slot)"
            value="time"
          ></mat-radio-button>
        </div>
      </div>
    </div>
  </section>
  <section *ngIf="isManageUser">
    <div *ngFor="let user of userList" class="mobile-table-card-container">
      <div class="card-content">
        <div>
          Name : <b> {{ user.firstName + " " + user.lastName }}</b>
        </div>

        <div>
          Date :
          <b>{{ getCFormatedDate(user.userAddDate) }}</b>
        </div>
        <div>
          Role : <b>{{ user.role }}</b>
        </div>
      </div>
      <div class="card-action">
        <button
          [ngStyle]="{
            'background-color':
              user.userStatus == 1 &&
              user.isManuallyVerified.toLowerCase() === 'false'
                ? 'green'
                : user.userStatus == 1 &&
                  user.isManuallyVerified.toLowerCase() === 'true'
                ? '#FFBF00'
                : user.userStatus == -1
                ? 'gray'
                : 'red'
          }"
          class="security-button"
          mat-raised-button
        >
          {{
            user.userStatus == -1
              ? "Pending"
              : (user.userStatus == 0 &&
                  user.isManuallyVerified.toLowerCase() === "false") ||
                user.isManuallyVerified == ""
              ? "Unverified"
              : user.userStatus == 1 &&
                user.isManuallyVerified.toLowerCase() === "false"
              ? "Verified"
              : user.userStatus == 1 &&
                user.isManuallyVerified.toLowerCase() === "true"
              ? "Manually Verified"
              : user.userStatus == 0 &&
                user.isManuallyVerified.toLowerCase() === "true"
              ? "Manually Unverified"
              : ""
          }}
        </button>
        <button (click)="onShowDetails(user)" mat-raised-button>Details</button>
      </div>
    </div>
  </section>
  <section *ngIf="isIncidentTimeline">
    <div
      *ngFor="let timeline of incidentTimeline.dataSource"
      class="mobile-table-card-container"
    >
      <div class="card-content">
        <div>
          Camera : <b>{{ incidentTimeline.sourceAsset }}</b>
        </div>

        <div>
          Location: <b>{{ incidentTimeline.incidentLocation }}</b>
        </div>
        <div>
          Date : <b>{{ timeline | date : "fullDate" }}</b>
        </div>
        <div>
          Time : <b>{{ timeline | date : "hh:mm:ss a" }}</b>
        </div>
      </div>
      <div *ngIf="false" class="card-action">
        <button (click)="onShowDetails(incidentTimeline)" mat-raised-button>
          Details
        </button>
      </div>
    </div>
  </section>
</div>
